import React, {Component} from 'react'
import InCardPage from './InCardPage'
import './../styles/index.scss'

class InCardContainer extends Component {
    render() {
        return (
            <div className="InCardContainer">
                <div className='bg-light p-3 mb-3'>
                    <InCardPage/>
                </div>
            </div>
        )
    }
}

export default InCardContainer